import { useMutation } from '@tanstack/react-query';
import BackendClient from '@/api/backendClient.ts';
import { BackendSuccessResponse } from '@/types/response/Api/BackendSuccessResponse';
import { BackendErrorResponse } from '@/types/response/Api/BackendErrorResponse';
import { transformBackendErrors } from '@/utils/transformBackendErrors.ts';

const useDeleteAccount = () => {
  const mutationFn = async () => {
    return sendDeleteAccountRequest();
  };

  return useMutation({
    mutationFn,
  });
};

export default useDeleteAccount;

async function sendDeleteAccountRequest(): Promise<void> {
  try {
    await BackendClient.delete<BackendSuccessResponse<void>>('/api/auth/delete');

    return;
  } catch (error: any) {
    if (error.response && error.response.data) {
      const errorResponse = error.response.data as BackendErrorResponse;

      throw new Error(transformBackendErrors(errorResponse).join(', '));
    }

    throw new Error(error.message ?? 'An error occurred while sending account delete request.');
  }
}
